import apiClient from './apiClient';

export interface SendImageRequest {
  conversationId: number;
  image: File;
  messageText?: string;
}

export interface SendImageResponse {
  success: boolean;
  message: string;
  data?: {
    messageId: number;
    imageUrl: string;
  };
}

export const imageService = {
  /**
   * Enviar imagem para cliente
   */
  async sendImageToClient(conversationId: number, image: File, messageText?: string): Promise<SendImageResponse> {
    const formData = new FormData();
    formData.append('image', image);
    formData.append('conversationId', conversationId.toString());
    if (messageText) {
      formData.append('messageText', messageText);
    }

    const response = await apiClient.post('/images/send-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  },

  /**
   * Upload de imagem para armazenamento
   */
  async uploadImage(conversationId: number, image: File): Promise<{ imageUrl: string }> {
    const formData = new FormData();
    formData.append('image', image);
    formData.append('conversationId', conversationId.toString());

    const response = await apiClient.post('/images/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  }
};
